import { z } from "zod";
import { okResponse, publicUser } from "../auth/auth.schemas.js";
// ── Role enum (matches onshelf.user_role pg enum) ───────────────────
export const userRole = z.enum([
    "tenant_admin",
    "ops_manager",
    "store_manager",
    "store_associate",
    "field_auditor",
    "viewer",
]);
// ── Role scope classification ───────────────────────────────────────
// A role is either "tenant" (sees every store in the tenant) or "store"
// (must have at least one store_users binding; sees only those stores).
// Single source of truth for both API and web side checks.
export const ROLE_SCOPE = {
    tenant_admin: "tenant",
    ops_manager: "tenant",
    viewer: "tenant",
    store_manager: "store",
    store_associate: "store",
    field_auditor: "store",
};
export function isTenantWideRole(r) {
    return ROLE_SCOPE[r] === "tenant";
}
export function isStoreScopedRole(r) {
    return ROLE_SCOPE[r] === "store";
}
// ── /users/me ────────────────────────────────────────────────────────
export const usersMeResponse = publicUser;
// ── /users/me/companies ──────────────────────────────────────────────
export const companyMembership = z.object({
    tenantId: z.string().uuid(),
    tenantName: z.string(),
    role: userRole,
    isDefault: z.boolean(),
});
export const companiesListResponse = z.object({
    items: z.array(companyMembership),
});
// ── /users/companies/:companyId/users ────────────────────────────────
export const tenantUserInfo = z.object({
    companyUserId: z.string().uuid(), // tenant_users.public_id
    userId: z.string().uuid(), // users.public_id
    email: z.string().email(),
    fullName: z.string().nullable(),
    role: userRole,
    isDefault: z.boolean(),
    createdAt: z.string().datetime(),
});
export const tenantUsersListResponse = z.object({
    items: z.array(tenantUserInfo),
});
// ── PATCH /users/company-users/:companyUserId ────────────────────────
export const updateCompanyUserRequest = z.object({
    role: userRole,
});
// ── DELETE /users/company-users/:companyUserId ───────────────────────
export const removeCompanyUserResponse = okResponse;
// ── POST /users/:userId/reset-password ───────────────────────────────
export const adminResetPasswordResponse = okResponse;
// ── /users/:userId/stores — per-user store assignments ───────────────
export const userStoresResponse = z.object({
    /**
     * "all"    — target user holds a tenant-wide role; store bindings are
     *            irrelevant (returns no storeIds).
     * "scoped" — target user holds a store-scoped role; storeIds is the
     *            full active store_users binding set.
     */
    mode: z.enum(["all", "scoped"]),
    storeIds: z.array(z.string().uuid()),
});
export const replaceUserStoresRequest = z.object({
    storeIds: z.array(z.string().uuid()).max(2000),
});
export const replaceUserStoresResponse = okResponse;
// ── /users/store-scoped-unbound — backfill banner data ──────────────
export const unboundStoreScopedUser = z.object({
    userId: z.string().uuid(),
    email: z.string().email(),
    role: userRole,
});
export const unboundStoreScopedUsersResponse = z.object({
    items: z.array(unboundStoreScopedUser),
});
//# sourceMappingURL=users.schemas.js.map